import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { PriceModule } from '@studiobuki/web-core/lib/price';
import { SectionBooksComponent } from './section-books.component';
import { BooksComponent } from './components/books/books.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { BookComponent } from './components/book/book.component';
import { ProductModule } from '../product/product.module';

@NgModule({
  declarations: [
    SectionBooksComponent,
    BooksComponent,
    CarouselComponent,
    BookComponent,
  ],
  imports: [
    CommonModule,
    ImageTitleModule,
    SwiperModule,
    ButtonModule,
    PriceModule,
    ProductModule,
  ],
  exports: [SectionBooksComponent],
})
export class SectionBooksModule {}
